import { Injectable, inject } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionService } from '@services/session.service';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
  private session = inject(SessionService);

  intercept(
    httpRequest: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (this.session.user()) {
      httpRequest = httpRequest.clone({
        setHeaders: {
          Authorization: 'Bearer ' + this.session.user()!.token,
          'Accept-Language': this.session.user()!.language || 'en',
        },
      });
    }
    return next.handle(httpRequest);
  }
}
